import { supabase } from "@/integrations/supabase/client";
import type { Character } from "@/types/character";
import { useQuery } from "@tanstack/react-query";

export const useCharacters = () => {
  return useQuery({
    queryKey: ["characters"],
    queryFn: async () => {
      const { data: charactersData, error: charactersError } = await supabase
        .from("characters")
        .select(
          `id, name, title, short_description, avatar_url, rating, created_at, updated_at`
        );
      if (charactersError) throw charactersError;
      return (charactersData as Character[]) || [];
    },
  });
};

export const useAvailableCharacters = (excludeIds: string[]) => {
  return useQuery({
    queryKey: ["available-characters", excludeIds],
    queryFn: async () => {
      let query = supabase.from("characters").select(`
          id,
          name,
          title,
          short_description,
          avatar_url,
          rating,
          created_at,
          updated_at,
          first_message_helper_text,
          tags (*)
        `);
      if (excludeIds.length > 0) {
        query = query.not(
          "id",
          "in",
          `(${excludeIds.map((id) => `"${id}"`).join(",")})`
        );
      }
      const { data: charactersData, error: charactersError } = await query;
      if (charactersError) throw charactersError;
      return charactersData;
    },
  });
};
